//@ts-nocheck
import Axios from 'axios'
import { SERVER_URL } from 'settings/constants'
import { buildWebStorage, setupCache } from 'axios-cache-interceptor'
import { ApiError } from './ApiError'

const responseCacheTime = +import.meta.env.VITE_CACHE_RESPONSES_TIME
const axios = Axios.create({
  baseURL: SERVER_URL,
})

const backendInstance = setupCache(axios, {
  ...(responseCacheTime && {
    ttl: responseCacheTime,
    storage: buildWebStorage(localStorage, 'axios-cache:'),
  }),
  methods: ['get'],
})

export function handleAxiosResponseError(err: unknown): never {
  if (Axios.isCancel(err)) throw err
  const e = err as { response?: { status?: number; data?: unknown } }

  if (!e.response) {
    throw new ApiError('Network error', 'NETWORK_ERROR', 0)
  }
  const data = e.response.data as
    | { error?: { code?: string; message?: string; correlationId?: string } }
    | undefined
  const errBody = data?.error
  if (errBody?.message) {
    throw new ApiError(
      errBody.message,
      errBody.code ?? 'APP_ERROR',
      e.response.status ?? 0,
      errBody.correlationId
    )
  }
  throw new ApiError(
    'Something went wrong',
    'INTERNAL_ERROR',
    e.response.status ?? 0
  )
}

backendInstance.interceptors.response.use(undefined, handleAxiosResponseError)

export default backendInstance
